var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80737 2.86239C8.80737 2.49758 9.10311 2.20184 9.46792 2.20184H13.8716C14.2364 2.20184 14.5321 2.49758 14.5321 2.86239C14.5321 3.22721 14.2364 3.52294 13.8716 3.52294H9.46792C9.10311 3.52294 8.80737 3.22721 8.80737 2.86239Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80737 5.06421C8.80737 4.69939 9.10311 4.40366 9.46792 4.40366H11.6698C12.0346 4.40366 12.3303 4.69939 12.3303 5.06421C12.3303 5.42902 12.0346 5.72476 11.6698 5.72476H9.46792C9.10311 5.72476 8.80737 5.42902 8.80737 5.06421Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63303 1.3211C4.14463 1.3211 1.3211 4.14463 1.3211 7.63303C1.3211 11.1214 4.14463 13.945 7.63303 13.945C11.1214 13.945 13.945 11.1214 13.945 7.63303C13.945 7.26822 14.2407 6.97248 14.6055 6.97248C14.9703 6.97248 15.2661 7.26822 15.2661 7.63303C15.2661 11.8511 11.8511 15.2661 7.63303 15.2661C3.415 15.2661 0 11.8511 0 7.63303C0 3.415 3.415 0 7.63303 0C7.99784 0 8.29358 0.295739 8.29358 0.66055C8.29358 1.02536 7.99784 1.3211 7.63303 1.3211Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4044 13.4045C13.6624 13.1465 14.0806 13.1465 14.3386 13.4045L15.8065 14.8724C16.0644 15.1303 16.0644 15.5486 15.8065 15.8065C15.5485 16.0645 15.1303 16.0645 14.8723 15.8065L13.4044 14.3386C13.1464 14.0807 13.1464 13.6624 13.4044 13.4045Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.62363aff.svg";
export { ForwardRef as ReactComponent };